// components/ColumnSelectionModal.js
import React from 'react';
import { ALL_COLUMNS, PERMANENT_COLUMNS } from '../../utils/tableConstants';

const ColumnSelectionModal = ({
  isOpen,
  tempSelectedColumns,
  selectAll,
  onToggleSelectAll,
  onToggleColumn,
  onConfirm,
  onCancel,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="column-selection-modal-overlay">
      <div className="column-selection-modal">
        <div className="column-selection-header">
          <h2>Select Fields</h2>
          <button 
            className="modal-close-btn" 
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        
        <div className="column-list-container">
          <div className="column-grid">
            {ALL_COLUMNS.map((column) => (
              <label 
                key={column.key} 
                className={`column-checkbox ${
                  PERMANENT_COLUMNS.includes(column.key) ? 'permanent' : ''
                }`}
              >
                <input 
                  className='check'
                  type="checkbox"
                  checked={tempSelectedColumns.includes(column.key)}
                  onChange={() => onToggleColumn(column.key)}
                  disabled={PERMANENT_COLUMNS.includes(column.key)}
                />
                <span>{column.label}</span>                  
              </label>
            ))}
          </div>
        </div>
        
        <div className="column-dropdown-actions"> 
          <button className="select-all-btn" onClick={onToggleSelectAll}>
            {selectAll ? 'Deselect All' : 'Select All'}
          </button>

          <button 
            className="btn-ok" 
            onClick={onConfirm}
          >
            OK
          </button>
          <button 
            className="btn-cancel" 
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectionModal;